module.exports = __webpack_public_path__ + "img/squid.95aa3eb4.jpg";